// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dCSF-","title":"NotFound_title__V8vvV","subtitle":"NotFound_subtitle__wcqNG","details":"NotFound_details__nKENt","btn":"NotFound_btn__U8YeP"};